module.exports = __webpack_public_path__ + "img/hero_faq3.33f9626e.jpg";